Drupal.behaviors.header_image_sidebar_page = {
  attach: function (context, settings) {
    'use strict';

    const sidebar = context.querySelector('.main-side-menu-block');
    const contentWrapper = context.querySelector('.main-content');

    if(sidebar) {
      window.addEventListener('resize', debounce(() => {
        if(isVisible(sidebar)) {
          contentWrapper.style.minHeight = sidebar.offsetHeight+'px';
        } else {
          contentWrapper.style.minHeight = "auto"
        }
      }, 100))

      // On init
      if(isVisible(sidebar))
        contentWrapper.style.minHeight = sidebar.offsetHeight+'px';
    }
  }
};

